import styled, { css } from 'styled-components'
import { Image } from 'semantic-ui-react'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 1rem 1.5rem;
`

interface ContainerProps {
  direction: 'column' | 'row'
  justify: string
  align: string
  padding: string
  maxWidth: string
  textAlign: string
}

export const Container = styled.div<Partial<ContainerProps>>`
  display: flex;
  flex-direction: ${props => props.direction || 'row'};
  justify-content: ${props => props.justify || 'center'};
  align-items: ${props => props.align || 'center'};
  width: 100%;
  max-width: ${props => props.maxWidth || 'none'};
  padding: ${props => props.padding || '0.5rem'};
  text-align: ${props => props.textAlign};
  span {
    margin-bottom: 5px;
  }
`

export const QLogo = styled(Image)`
  &&& {
    width: ${props => props.width ?? '50px'};
    height: auto;
  }
`

export const HorizontalLine = styled.div`
  width: 100%;
  max-width: 500px;
  text-align: center;
  border-bottom: ${props => `1px solid ${props.theme.colors.dimGray}`};
  line-height: 0.1em;
  margin: 10px 0 20px;
  color: ${props => props.theme.colors.dimGray};
  span {
    background: ${({ theme }) => theme.colors.white};
    padding: 0 10px;
    font-size: 1.2rem;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0 3rem;
`

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`

interface StyledSpanProps {
  link?: boolean
  welcome?: boolean
  error?: boolean
}

export const StyledSpan = styled.span<StyledSpanProps>`
  ${props =>
    props.link &&
    css`
      color: ${({ theme }) => theme.colors.sapphireBlue};
      margin: 10px;
      cursor: pointer;
    `}
  ${props =>
    props.error &&
    css`
      color: ${({ theme }) => theme.colors.carnelian};
      align-self: flex-start;
      margin-bottom: 5px;
    `}
  ${props =>
    props.welcome &&
    css`
      text-align: center;
      font-size: 1.5em;
      margin: 5px 0;
    `}
`

export const ErrorMsg = styled.span`
  color: ${({ theme }) => theme.colors.carnelian};
  align-self: flex-start;
  margin-bottom: 5px;
`

export const PaymentInfoContainer = styled(Container)`
  padding: 0 10px;
  flex-direction: column;
  @media ${({ theme }) => theme.device.sm} {
    padding: 0 25%;
  }
`
